export function formatDocumentDate(value: string): string {
  return new Date(value).toLocaleDateString();
}
